window.chartInterop = {

    initializeChart: (canvasId, config) =>
    {
        config = cleanConfig(config);
        parseCallbacks(config.options);

        const ctx = document.getElementById(canvasId).getContext('2d');

        // Check if ANY dataset has valid (non-null, non-zero) data
        const hasValidData = config.data && 
            config.data.datasets && 
            config.data.datasets.length > 0 && 
            config.data.datasets.some(dataset => 
                dataset.data && 
                dataset.data.length > 0 && 
                dataset.data.some(value => value !== null && value !== undefined && value !== 0)
            );

        if (!hasValidData)
        {
            config = createDefaultGrayChartConfig(config, canvasId);
            config.options.plugins.tooltip.enabled = false;

        }
        else
        {

            if (canvasId != "past_years_line")
            {
                applyChartPatterns(config.data, canvasId);

                // Add shadow effect for student discipline bar charts
                if (config.type === 'bar' && (canvasId.includes('student_discipline_bar_suspension') || canvasId.includes('student_discipline_bar_arrests'))) {
                    // Store scale values for animation
                    const barScales = new Map(); // Map of bar index to scale value
                    
                    const originalBarController = Chart.controllers.bar;
                    Chart.controllers.bar = class extends originalBarController {
                        initialize() {
                            super.initialize();
                            // Initialize animation properties
                            this.animationProgress = 0;
                        }
                        
                        draw() {
                            const ctx = this.chart.ctx;
                            const meta = this.getMeta();
                            const activeElements = this.chart.getActiveElements();
                            
                            // Apply permanent shadow to all bars
                            ctx.save();
                            ctx.shadowColor = 'rgba(0, 0, 0, 0.3)';
                            ctx.shadowBlur = 10;
                            ctx.shadowOffsetX = 0;
                            ctx.shadowOffsetY = 6;
                            
                            // Get set of active element indices
                            const activeIndices = new Set();
                            if (activeElements && activeElements.length > 0) {
                                activeElements.forEach(el => {
                                    if (el.datasetIndex === meta.index) {
                                        activeIndices.add(el.index);
                                    }
                                });
                            }
                            
                            // Animate scale values
                            meta.data.forEach((bar, index) => {
                                const targetScale = activeIndices.has(index) ? 1.0 : 0.0;
                                const currentScale = barScales.get(index) || 0.0;
                                
                                // Smooth interpolation (lerp) towards target
                                const newScale = currentScale + (targetScale - currentScale) * 0.15;
                                barScales.set(index, newScale);
                            });
                            
                            // Draw each bar with scaling for active ones
                            meta.data.forEach((bar, index) => {
                                ctx.save();
                                
                                const scaleProgress = barScales.get(index) || 0.0;
                                
                                // Apply scaling based on animation progress
                                if (scaleProgress > 0.01) {
                                    const centerX = bar.x;
                                    const baseY = bar.base;
                                    
                                    // Interpolate scale values
                                    const scaleX = 1 + (0.03 * scaleProgress);
                                    const scaleY = 1 + (0.05 * scaleProgress);
                                    
                                    // Translate to bar center, scale, then translate back
                                    ctx.translate(centerX, baseY);
                                    ctx.scale(scaleX, scaleY);
                                    ctx.translate(-centerX, -baseY);
                                    
                                    // Enhanced shadow for active bar (interpolated)
                                    const shadowOpacity = 0.3 + (0.1 * scaleProgress);
                                    ctx.shadowColor = `rgba(0, 0, 0, ${shadowOpacity})`;
                                    ctx.shadowBlur = 10 + (5 * scaleProgress);
                                    ctx.shadowOffsetY = 6 + (4 * scaleProgress);
                                }
                        
                                bar.draw(ctx);
                                ctx.restore();
                            });
                            
                            ctx.restore();
                            
                            // Continue animation if any bar is still animating
                            const isAnimating = Array.from(barScales.values()).some((scale, index) => {
                                const isActive = activeIndices.has(index);
                                const target = isActive ? 1.0 : 0.0;
                                return Math.abs(scale - target) > 0.01;
                            });
                            
                            if (isAnimating) {
                                this.chart.update('none'); // Update without re-running animations
                            }
                        }
                    };
                }

                // Background "meter" bars for teacher experience chart
                if (config.type === 'bar' && canvasId === 'teacher_experience_bar') {
                    // Remove the baseline border
                    config.options.scales = config.options.scales || {};
                    config.options.scales.x = config.options.scales.x || {};
                    config.options.scales.x.border = { display: false };
                    config.options.scales.y = config.options.scales.y || {};
                    config.options.scales.y.border = { display: false };

                    // Apply mobile-aware orientation: horizontal bars on narrow viewports
                    // give each Years group its own row so the % / N labels have room.
                    applyTeacherExperienceOrientation(config.options, isTeacherExperienceMobile());

                    config.plugins = config.plugins || [];
                    config.plugins.push({
                        id: 'backgroundBars',
                        beforeDatasetsDraw(chart) {
                            const { ctx, chartArea } = chart;
                            const { top, bottom, left, right } = chartArea;
                            const numDatasets = chart.data.datasets.length;
                            if (numDatasets === 0) return;

                            const isHorizontal = chart.options.indexAxis === 'y';
                            ctx.save();
                            ctx.fillStyle = '#e8e8e8';
                            const radius = 4;

                            for (let dsIndex = 0; dsIndex < numDatasets; dsIndex++) {
                                const meta = chart.getDatasetMeta(dsIndex);
                                if (!meta || !meta.data) continue;
                                for (let i = 0; i < meta.data.length; i++) {
                                    const bar = meta.data[i];
                                    let rx, ry, rw, rh;
                                    if (isHorizontal) {
                                        rw = right - left;
                                        rh = bar.height;
                                        rx = left;
                                        ry = bar.y - rh / 2;
                                    } else {
                                        rw = bar.width;
                                        rh = bottom - top;
                                        rx = bar.x - rw / 2;
                                        ry = top;
                                    }
                                    ctx.beginPath();
                                    ctx.moveTo(rx + radius, ry);
                                    ctx.lineTo(rx + rw - radius, ry);
                                    ctx.quadraticCurveTo(rx + rw, ry, rx + rw, ry + radius);
                                    ctx.lineTo(rx + rw, ry + rh - radius);
                                    ctx.quadraticCurveTo(rx + rw, ry + rh, rx + rw - radius, ry + rh);
                                    ctx.lineTo(rx + radius, ry + rh);
                                    ctx.quadraticCurveTo(rx, ry + rh, rx, ry + rh - radius);
                                    ctx.lineTo(rx, ry + radius);
                                    ctx.quadraticCurveTo(rx, ry, rx + radius, ry);
                                    ctx.closePath();
                                    ctx.fill();
                                }
                            }
                            ctx.restore();
                        }
                    });

                    // Plugin to draw percentage + teacher count labels.
                    // Vertical layout: % above the bar, N count below.
                    // Horizontal layout: "% — N" inline to the right of each bar's row.
                    config.plugins.push({
                        id: 'barLabels',
                        afterDatasetsDraw(chart) {
                            const { ctx, chartArea } = chart;
                            const { top, bottom, right } = chartArea;
                            const isHorizontal = chart.options.indexAxis === 'y';
                            ctx.save();
                            ctx.font = '500 13px sans-serif';
                            ctx.fillStyle = '#333';

                            chart.data.datasets.forEach(function (dataset, dsIndex) {
                                const meta = chart.getDatasetMeta(dsIndex);
                                if (!meta || !meta.data) return;
                                meta.data.forEach(function (bar, index) {
                                    const pct = dataset.pointLabels && dataset.pointLabels[index];
                                    const n = dataset.nSizeLabels && dataset.nSizeLabels[index];
                                    if (isHorizontal) {
                                        ctx.textAlign = 'left';
                                        ctx.textBaseline = 'middle';
                                        const parts = [];
                                        if (pct) parts.push(pct);
                                        if (n) parts.push(n);
                                        if (parts.length) {
                                            ctx.fillText(parts.join('  '), right + 6, bar.y);
                                        }
                                    } else {
                                        ctx.textAlign = 'center';
                                        ctx.textBaseline = 'alphabetic';
                                        if (pct) ctx.fillText(pct, bar.x, top - 8);
                                        if (n) ctx.fillText(n, bar.x, bottom + 16);
                                    }
                                });
                            });
                            ctx.restore();
                        }
                    });
                }

                // Doughnut tooltips get clipped by the small fixed canvas; render them as HTML.
                if (config.type === 'doughnut')
                {
                    applyExternalTooltip(config);
                }

                //const originalDoughnutController = Chart.controllers.doughnut;
                //Chart.controllers.doughnut = class extends originalDoughnutController
                //{
                //    draw()
                //    {
                //        let ctx = this.chart.ctx;
                //        ctx.save();
                //        ctx.shadowColor = '#000000';
                //        ctx.shadowBlur = 1;
                //        ctx.shadowOffsetX = 0;
                //        ctx.shadowOffsetY = 1;
                //        super.draw();
                //        ctx.restore();
                //    }
                //};

            }

            if (canvasId == "past_years_line")
            {
                config.options.plugins.legend.onHover = function (event, legendItem, legend)
                {
                    var options = this.options || {};
                    var hoverOptions = options.hover || {};
                    var ci = this.chart;
                    hoveredDatasetIndex = legendItem.datasetIndex;
                    var activeElements = [];

                    //restore original border width
                    ci.config.data.datasets.forEach((dataset, index) =>
                    {
                        dataset.borderWidth[0] = 2;
                        dataset.borderColor[0] = dataset.pointBorderColor;

                    });

                    ci.config.data.datasets[hoveredDatasetIndex].borderWidth[0] = 4;
                    ci.config.data.datasets[hoveredDatasetIndex].borderColor[0] = ci.config.data.datasets[hoveredDatasetIndex].pointHoverBorderColor;
                    ci.config.data.datasets[hoveredDatasetIndex].data.forEach((dataItem, index) =>
                    {
                        var element = { datasetIndex: hoveredDatasetIndex, index: index };
                    
                        activeElements.push(element);

                    });
                    ci.setActiveElements(activeElements);
                    ci.render();
                    ci.update();
                }

                const originalLineController = Chart.controllers.line;
                Chart.controllers.line = class extends originalLineController
                {
                    draw()
                    {
                        let ctx = this.chart.ctx;
                        ctx.save();
                        ctx.shadowColor = '#000000';
                        ctx.shadowBlur = 2;
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 1;
                        super.draw();
                        ctx.restore();
                    }
                };

                // Store the original controller for cleanup
                window.originalLineController = originalLineController;

                // Apply dashed line style to the dataset with label "All Student Group"
                config.data.datasets.forEach(dataset =>
                {
                    if (dataset.label === "All Student Group")
                    {
                        dataset.borderDash = [5, 5]; // Dash pattern: 5px dash, 5px gap
                    }
                });
            }
        }

        const chart = new Chart(ctx, config);

        window.myCharts = window.myCharts || {};
        window.myCharts[canvasId] = chart;

        if (canvasId === 'teacher_experience_bar') {
            window._teacherExperienceMobileState = window._teacherExperienceMobileState || {};
            window._teacherExperienceMobileState.teacher_experience_bar = isTeacherExperienceMobile();
        }

        return chart;
    },

    destroyChart: function (canvasId)
    {
        if (window.myCharts && window.myCharts[canvasId])
        {
            window.myCharts[canvasId].destroy();
            delete window.myCharts[canvasId];
        }

        // Remove any HTML tooltip element created for this canvas.
        const ttEl = document.getElementById('chartjs-ext-tooltip-' + canvasId);
        if (ttEl && ttEl.parentNode)
        {
            ttEl.parentNode.removeChild(ttEl);
        }
    },

    updateChart: (chartRef, newData, newOptions) =>
    {

        const chart = chartRef;
        if (chart)
        {
            if (newData)
            {

                if (chartRef.canvas.id != "past_years_line")
                {
                    applyChartPatterns(newData, chartRef.canvas.id);
                }

                chart.data = newData;

            }

            if (newOptions)
            {
                chart.config.options = newOptions;
                chart.config = cleanConfig(chart.config);
                parseCallbacks(chart.config.options);

                // Apply dashed line style to the dataset with label "All Student Group"
                chart.config.data.datasets.forEach(dataset =>
                {
                    if (dataset.label === "All Student Group")
                    {
                        dataset.borderDash = [5, 5]; // Dash pattern: 5px dash, 5px gap
                    }
                });

            }

            // Check if ANY dataset has valid (non-null, non-zero) data
            const hasValidData = chart.config.data && 
                chart.config.data.datasets && 
                chart.config.data.datasets.length > 0 && 
                chart.config.data.datasets.some(dataset => 
                    dataset.data && 
                    dataset.data.length > 0 && 
                    dataset.data.some(value => value !== null && value !== undefined && value !== 0)
                );

            if (!hasValidData)
            {
                chart.config = createDefaultGrayChartConfig(chart.config, chartRef.canvas.id);
                chart.config.options.plugins.tooltip.enabled = false;
            }
            else
            {
                // Re-apply the HTML tooltip: updateChart replaced options with the
                // C# config, which doesn't carry the external handler.
                applyExternalTooltip(chart.config);
            }

            chart.update();


        }
    },
    
    clearActiveElement: (chartRef) => {
        const chart = chartRef;
        chart.setActiveElements([]);
        chart.tooltip.setActiveElements([]);
        chart.update();
    },

    setActiveElement: (chartRef, datasetIndex, index) => {
        const chart = chartRef;

        if (!chart)
        {
            console.warn("setActiveElement: chart reference is not valid.");
            return;
        }

        const datasets = chart.data?.datasets;
        if (!Array.isArray(datasets) || datasets.length === 0)
        {
            console.warn("setActiveElement: chart has no datasets.");
            return;
        }

        if (typeof datasetIndex !== 'number' || datasetIndex < 0 || datasetIndex >= datasets.length)
        {
            console.warn("setActiveElement: invalid datasetIndex", datasetIndex, "datasetCount:", datasets.length, "chartId:", chart.canvas?.id);
            return;
        }

        const dataArray = datasets[datasetIndex]?.data;
        if (!Array.isArray(dataArray) || dataArray.length === 0)
        {
            console.warn("setActiveElement: dataset has no data.", "datasetIndex:", datasetIndex, "chartId:", chart.canvas?.id);
            return;
        }

        if (typeof index !== 'number' || index < 0 || index >= dataArray.length)
        {
            console.warn("setActiveElement: invalid data index", index, "dataCount:", dataArray.length, "datasetIndex:", datasetIndex, "chartId:", chart.canvas?.id);
            return;
        }

        // If the target data point isn't numeric (null/undefined/string), Chart.js can behave inconsistently.
        const pointValue = dataArray[index];
        if (pointValue === null || pointValue === undefined || (typeof pointValue !== 'number' && typeof pointValue !== 'bigint'))
        {
            console.warn("setActiveElement: target value is not numeric", { datasetIndex, index, valueType: typeof pointValue, chartId: chart.canvas?.id });
            return;
        }

        chart.setActiveElements([{ datasetIndex: datasetIndex, index: index }]);
        if (chart.tooltip && typeof chart.tooltip.setActiveElements === 'function')
        {
            chart.tooltip.setActiveElements([{ datasetIndex: datasetIndex, index: index }]);
        }
        chart.update();

        setTimeout(() =>
        {
            const activeElements = chartRef.getActiveElements();

            if (activeElements.length > 0)
            {
                const activeElement = activeElements[0];
                const activeDatasetIndex = activeElement.datasetIndex;
                const activeIndex = activeElement.index;

                if (activeDatasetIndex === datasetIndex && activeIndex === index)
                {
                    chart.setActiveElements([]);
                    if (chart.tooltip && typeof chart.tooltip.setActiveElements === 'function')
                    {
                        chart.tooltip.setActiveElements([]);
                    }
                    chart.update();
                }
            }
        }, 2000);
    },

    setActiveDataset: (chartRef, datasetIndex) =>
    {
        const chart = chartRef;

        if (chart)
        {
            // Validate dataset index
            if (datasetIndex < 0 || datasetIndex >= chart.data.datasets.length)
            {
                console.error("Invalid dataset index:", datasetIndex);
                return;
            }

            const datasetElements = chart.getDatasetMeta(datasetIndex).data;

            if (!datasetElements || datasetElements.length === 0)
            {
                console.warn(`No elements found for dataset index: ${datasetIndex}`);
                return;
            }

            const activeElements = datasetElements.map((_, index) => ({
                datasetIndex: datasetIndex,
                index: index,
            }));

            chart.setActiveElements(activeElements);

            chart.update();
        } else
        {
            console.error("Chart reference is not valid.");
        }
    },

    downloadChartImage: (canvasId) =>
    {
        const canvas = document.getElementById(canvasId);
        if (canvas)
        {
            const link = document.createElement('a');
            link.href = canvas.toDataURL('image/png');
            link.download = 'chart-image.png';
            link.click();
        } else
        {
            console.error(`Canvas with ID ${canvasId} not found.`);
        }
    },

    downloadChartPanel: async (panelId, filename = 'chart-panel.png') =>
    {
        const panelElement = document.getElementById(panelId);
        if (!panelElement)
        {
            console.error(`Panel element with ID ${panelId} not found.`);
            return;
        }

        try
        {
            // Check if html2canvas is available
            if (typeof html2canvas === 'undefined')
            {
                console.error('html2canvas library is not loaded. Please include it in your project.');
                return;
            }

            // Capture the panel element
            const canvas = await html2canvas(panelElement, {
                backgroundColor: '#ffffff',
                scale: 2, // Higher quality
                logging: false,
                useCORS: true,
                allowTaint: true
            });

            // Convert to blob and download
            canvas.toBlob((blob) =>
            {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                link.click();
                URL.revokeObjectURL(link.href);
            }, 'image/png');

        } catch (error)
        {
            console.error('Error capturing chart panel:', error);
        }
    },

    yAxisPercentageFormatter: function (value)
    {
        return value + "%"; // Format y-axis tick values as percentages
    },

    tooltipPercentageFormatter: function (context)
    {
        //return context.raw !== undefined ? context.raw + "%" : ""; // Format tooltip values as percentages
        if (context && context.raw !== undefined && context.dataset.label === "")
        {
            return `${context.raw}%`;
        }
        else if (context && context.raw !== undefined)
        {
            return `${context.dataset.label}
            ${context.raw}%`;
        }
        else
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }
    },

    tooltipDollarFormatter: function (context)
    {
        if (context && context.raw !== undefined)
        {
            const formattedValue = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                maximumFractionDigits: 0
            }).format(context.raw);

            if (context.dataset.label === "")
            {
                return `${formattedValue}`;
            } else
            {
                return `${context.dataset.label} ${formattedValue}`;
            }
        } else
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }
    },

    tooltipCategoryCountFormatter: function (context)
    {
        if (!context || context.raw === undefined)
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }

        // Try all possible casing variations
        const pointLabels = context.dataset?.pointLabels || 
                           context.dataset?.PointLabels || 
                           context.dataset?.pointlabels;
        
         const label = pointLabels && pointLabels.length > context.dataIndex
             ? pointLabels[context.dataIndex]
             : (context.label ?? "");
        
         const formattedValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(context.raw);
         return `${label}: ${formattedValue}`;
    },

    tooltipEmptyTitleFormatter: function ()
    {
        return '';
    },

    // Disaggregate doughnuts (Teacher Workforce) carry a label only on the primary slice
    // (a percentage, or the "Not Available: ..." message). The remainder slice is intentionally
    // unlabeled so no "Remainder: 100" tooltip appears; return '' to suppress it.
    tooltipDisaggregateDonutFormatter: function (context)
    {
        if (context && context.dataIndex === 0)
        {
            return context.label || '';
        }
        return '';
    },

    tooltipCountFormatter: function (context)
    {
        if (context && context.raw !== undefined && context.dataset.label === "")
        {
            const formattedValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(context.raw);
            return formattedValue;
        }
        else if (context && context.raw !== undefined)
        {
            const formattedValue = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(context.raw);
            return `${context.dataset.label}: ${formattedValue}`;
        }
        else
        {
            console.error("Tooltip context is null or invalid");
            return "No data";
        }
    },

    yAxisCountFormatter: function (value)
    {
        return new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 }).format(value);
    },

    // Chart.js draws tooltips onto the canvas bitmap, so on a small fixed-size
    // canvas (e.g. the 225x225 doughnuts) a wide label gets clipped at the edge.
    // This renders the tooltip as an HTML element appended to <body>, which can
    // overflow the canvas/panel freely and never clips.
    externalTooltipHandler: function (context)
    {
        const chart = context.chart;
        const tooltip = context.tooltip;
        const el = getOrCreateChartTooltipEl(chart);

        // Hide when Chart.js signals no active tooltip.
        if (!tooltip || tooltip.opacity === 0)
        {
            el.style.opacity = 0;
            return;
        }

        const titleLines = tooltip.title || [];
        const bodyLines = (tooltip.body || []).map(b => b.lines);

        let html = '';
        let hasContent = false;
        titleLines.forEach(function (line)
        {
            if (line && String(line).trim() !== '')
            {
                html += '<div style="font-weight:600;margin-bottom:2px;">' + escapeChartTooltipHtml(line) + '</div>';
                hasContent = true;
            }
        });
        bodyLines.forEach(function (lines)
        {
            (lines || []).forEach(function (line)
            {
                if (line && String(line).trim() !== '')
                {
                    html += '<div>' + escapeChartTooltipHtml(line) + '</div>';
                    hasContent = true;
                }
            });
        });

        // Nothing to show (e.g. hovering an unlabeled remainder slice) — keep the tooltip hidden
        // instead of flashing an empty box.
        if (!hasContent)
        {
            el.style.opacity = 0;
            return;
        }

        el.querySelector('.chartjs-ext-tooltip-content').innerHTML = html;

        // Position in page coordinates relative to the canvas caret.
        const rect = chart.canvas.getBoundingClientRect();
        el.style.opacity = 1;
        el.style.left = (rect.left + window.scrollX + tooltip.caretX) + 'px';
        el.style.top = (rect.top + window.scrollY + tooltip.caretY - 8) + 'px';
    },


};

// Creates (once per canvas) the <body>-level element used by externalTooltipHandler.
function getOrCreateChartTooltipEl(chart)
{
    const canvasId = (chart.canvas && chart.canvas.id) ? chart.canvas.id : 'default';
    const id = 'chartjs-ext-tooltip-' + canvasId;
    let el = document.getElementById(id);
    if (!el)
    {
        el = document.createElement('div');
        el.id = id;
        el.style.cssText = 'position:absolute;pointer-events:none;z-index:1080;' +
            'background:rgba(0,0,0,0.85);color:#fff;border-radius:6px;padding:8px 10px;' +
            'font-size:13px;line-height:1.3;white-space:nowrap;transform:translate(-50%,-100%);' +
            'transition:opacity .15s ease;opacity:0;box-shadow:0 2px 8px rgba(0,0,0,0.3);';
        el.innerHTML = '<div class="chartjs-ext-tooltip-content"></div>';
        document.body.appendChild(el);
    }
    return el;
}

function escapeChartTooltipHtml(str)
{
    return String(str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
}

// Switches a doughnut chart from the canvas-drawn tooltip (which clips on small
// canvases) to the non-clipped HTML tooltip. No-op for other chart types.
function applyExternalTooltip(config)
{
    if (!config || config.type !== 'doughnut') return;
    config.options = config.options || {};
    config.options.plugins = config.options.plugins || {};
    const tt = config.options.plugins.tooltip = config.options.plugins.tooltip || {};
    tt.enabled = false;
    tt.external = window.chartInterop.externalTooltipHandler;
}

function createDefaultGrayChartConfig(config, canvasId)
{
    // Preserve the labels from C# if they exist (they contain MeasureService labels like N/A, N/AV, N*, etc.)
    const originalLabels = config.data?.labels || ['No Data'];
    
    config.data = {
        labels: originalLabels,  // Use labels from C# instead of hardcoding "No Data"
        datasets: [{
            label: 'No Data',
            data: [1],
            backgroundColor: ['gray'],
            borderColor: 'gray',
            borderWidth: 1
        }]
    };

    const patterns = drawPatterns(config.data);
    config.data.datasets[0].backgroundColor = patterns;
    applyPatternsToCircleIndicators(patterns, canvasId);

    return config;

}

function cleanConfig(config)
{
    // Remove null values from the config object
    if (typeof config === 'object' && config !== null)
    {
        for (const key in config)
        {
            if (config[key] === null)
            {
                delete config[key];
            } else if (typeof config[key] === 'object')
            {
                cleanConfig(config[key]); // Recursively clean nested objects
            }
        }
    }
    return config;
}

function parseCallbacks(options)
{
    for (const key in options)
    {
        if (options.hasOwnProperty(key))
        {
            const value = options[key];

            // Process only properties named 'callback' (case-insensitive)
            if (typeof value === 'string' && value.includes('.'))
            {
                const parts = value.split('.');
                let func = window;

                for (const part of parts)
                {
                    func = func[part];
                    if (!func) break;
                }

                if (typeof func === 'function')
                {
                    options[key] = func;
                }
            }

            // Recursively parse nested objects
            if (typeof value === 'object' && value !== null)
            {
                parseCallbacks(value);
            }
        }
    }
}

function darkenColor(color, amount = 20)
{
    
    if (Array.isArray(color))
    {
        color = color[0];
    }

    const colorParts = color.match(/\d+/g).map(Number);
    const [r, g, b] = colorParts;
    return `rgb(${Math.max(0, r - amount)}, ${Math.max(0, g - amount)}, ${Math.max(0, b - amount)})`;
}

function ColorLuminance(hex, lum)
{

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6)
    {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++)
    {
        c = parseInt(hex.substr(i * 2, 2), 16);
        c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
        rgb += ("00" + c).substr(c.length);
    }

    return rgb;
}

// Convert a "patternType, color" string into a CanvasPattern (or raw color for "solid").
function buildPattern(item) {
    if (typeof item !== 'string' || !item.includes(',')) return item;
    var parts = item.split(',');
    var patternType = parts[0].trim();
    var color = parts[1].trim();
    if (patternType === 'solid') return color;
    return pattern.draw(patternType, color);
}

// Shared pattern application for both initializeChart and updateChart.
// Modifies configData.datasets[*].backgroundColor in place and refreshes circle indicators.
function applyChartPatterns(configData, canvasId) {
    if (!configData || !configData.datasets || configData.datasets.length === 0) return;

    if (configData.datasets.length > 1) {
        // Multi-dataset (e.g. teacher experience bar): one pattern per dataset
        var allPatterns = [];
        configData.datasets.forEach(function (dataset) {
            if (dataset.backgroundColor && dataset.backgroundColor.length > 0 &&
                typeof dataset.backgroundColor[0] === 'string' && dataset.backgroundColor[0].includes(',')) {
                var dsPattern = buildPattern(dataset.backgroundColor[0]);
                dataset.backgroundColor = dataset.data.map(function () { return dsPattern; });
                allPatterns.push(dsPattern);
            }
        });
        if (allPatterns.length > 0) {
            applyPatternsToCircleIndicators(allPatterns, canvasId);
        }
    } else {
        // Single-dataset (e.g. doughnut, single-series bar)
        var patterns = drawPatterns(configData);
        if (patterns) {
            configData.datasets[0].backgroundColor = patterns;
            applyPatternsToCircleIndicators(patterns, canvasId);
        }
    }
}

function drawPatterns(configData) {

    if (!configData.datasets || configData.datasets.length === 0 || configData.datasets[0].backgroundColor.length === 0) {
        return null;
    }

    var backgroundColors = configData.datasets[0].backgroundColor;

    if (backgroundColors.some(color => !color.includes(',')))
    {
        return pattern.draw('circle', 'gray');
    }

    //using patternomaly
    var patterns = backgroundColors.map(function (item) {
        var parts = item.split(','); // Split "pattern,color" string
        var patternType = parts[0].trim();
        var color = parts[1].trim();
        if (patternType === 'solid') {
            return color; // bypass patternomaly for solid fills
        }
        return pattern.draw(patternType, color);
    });

    ////using patternomaly
    //var patterns = [
    //    pattern.draw('square', '#1f77b4'),
    //    pattern.draw('circle', '#ff7f0e'),
    //    pattern.draw('diamond', '#2ca02c'),
    //    pattern.draw('zigzag-horizontal', '#17becf'),
    //    pattern.draw('triangle', 'rgb(255, 99, 132, 0.4)') // with opacity
    //];

    return patterns;
}

function applyPatternsToCircleIndicators(patternArray, canvasId) {
    if (patternArray == null || patternArray.length === 0) {
        return;
    }

    var classNames = [];

    if (canvasId == "enrollment_race_doughnut")
    {
        classNames = ['asian',
            'black',
            'hispanic',
            'american-indian',
            'hawaiian',
            'multiracial',
            'white',
            'federal',
            'statelocal'
        ];
    }
    else if (canvasId.includes("per-pupil"))
    {
        classNames = ['statelocal',
            'federal'
        ];
    } else if (canvasId.includes("student_discipline_bar_suspension")) {
        classNames = ['inSchoolSusp',
            'outSchoolSusp',
            'expulsions',
        ];
    } else if (canvasId.includes("student_discipline_bar_arrests")) {
        classNames = ['arrests',
            'referrals',
        ];
    } else if (canvasId.includes("student_discipline_doughnut_violence")) {
        classNames = ['violence-attackNoWeapon',
            'violence-attackWithWeapon',
            'violence-battery',
            'violence-rape',
            'violence-possessionFirearm',
            'violence-robberyWithWeapon',
            'violence-robberyNoWeapon',
            'violence-threatWithWeapon',
            'violence-threatNoWeapon',
            'violence-bullyingDisability',
            'violence-bullyingRace',
            'violence-bullyingSex',
            'violence-bullyingReligion',
            'violence-bullyingSexualOrientation',
        ];
    } else if (canvasId.includes("teacher_experience_bar")) {
        classNames = ['tw-school', 'tw-district', 'tw-state'];
    }

    document.querySelectorAll('.chart-color-indicator').forEach((element) => {
        const className = classNames.find(cls => element.classList.contains(cls));
        const pattern = patternArray[classNames.indexOf(className)];

        if (className && pattern) {
            // Create a temporary canvas to render the pattern
            const canvas = document.createElement('canvas');
            canvas.width = 30; // Match the indicator size
            canvas.height = 30;

            const ctx = canvas.getContext('2d');
            ctx.fillStyle = pattern; // Set the CanvasPattern as fillStyle
            ctx.fillRect(0, 0, canvas.width, canvas.height); // Fill the canvas

            // Convert the canvas to a data URL and apply it as background-image
            element.style.backgroundImage = `url(${canvas.toDataURL()})`;
        }
    });

}

// Function to apply patterns directly from pattern strings (for when chart hasn't initialized yet)
function applyPatternsFromStrings(canvasId) {
    // Check if pattern library is loaded
    if (typeof pattern === 'undefined' || typeof pattern.draw !== 'function') {
        setTimeout(function() {
            applyPatternsFromStrings(canvasId);
        }, 100);
        return;
    }

    var patternStrings = [];
    var classNames = [];

    if (canvasId.includes("student_discipline_bar_suspension")) {
        patternStrings = [
            "line, #FC802D",
            "ring, #1916C7",
            "line-vertical, #0A0E29"
        ];
        classNames = ['inSchoolSusp', 'outSchoolSusp', 'expulsions'];
    } else if (canvasId.includes("student_discipline_bar_arrests")) {
        patternStrings = [
            "line, #FC802D",
            "ring, #1916C7",
            "line-vertical, #0A0E29"
        ];
        classNames = ['arrests', 'referrals', 'violence'];
    }

    if (patternStrings.length === 0) {
        return;
    }

    // Track retry attempts to prevent infinite loops
    if (!window._patternRetryCount) {
        window._patternRetryCount = {};
    }
    if (!window._patternRetryCount[canvasId]) {
        window._patternRetryCount[canvasId] = 0;
    }
    
    // Check if elements exist
    var foundElements = false;
    classNames.forEach(className => {
        var elements = document.querySelectorAll('.chart-color-indicator.' + className);
        if (elements.length > 0) {
            foundElements = true;
        }
    });

    if (!foundElements) {
        // Limit retries to 20 attempts (2 seconds total)
        if (window._patternRetryCount[canvasId] < 20) {
            window._patternRetryCount[canvasId]++;
                setTimeout(function() {
                    applyPatternsFromStrings(canvasId);
                }, 100);
        }
        return;
    }

    // Reset retry count on success
    window._patternRetryCount[canvasId] = 0;

    // Create patterns from strings
    var patterns = patternStrings.map(function (item) {
        var parts = item.split(',');
        var patternType = parts[0].trim();
        var color = parts[1].trim();
        if (patternType === 'solid') {
            return color;
        }
        return pattern.draw(patternType, color);
    });

    // Apply patterns to indicators
    classNames.forEach((className, index) => {
        var elements = document.querySelectorAll('.chart-color-indicator.' + className);
        elements.forEach(element => {
            if (patterns[index]) {
                const canvas = document.createElement('canvas');
                canvas.width = 30;
                canvas.height = 30;
                const ctx = canvas.getContext('2d');
                ctx.fillStyle = patterns[index];
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                element.style.backgroundImage = `url(${canvas.toDataURL()})`;
            }
        });
    });
}

// Apply patterns on DOM ready for student discipline charts
document.addEventListener('DOMContentLoaded', function() {
    // Apply patterns for both student discipline charts
    applyPatternsFromStrings('student_discipline_bar_suspension');
    applyPatternsFromStrings('student_discipline_bar_arrests');
});

// For Blazor apps, also try after a delay to ensure components are rendered
setTimeout(function() {
    applyPatternsFromStrings('student_discipline_bar_suspension');
    applyPatternsFromStrings('student_discipline_bar_arrests');
}, 1000); // Increased delay to ensure Blazor rendering

// Watch for chart indicators being added to the DOM
const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
                // Check if this is a chart color indicator or contains one
                if (node.classList && (
                    node.classList.contains('inSchoolSusp') ||
                    node.classList.contains('outSchoolSusp') ||
                    node.classList.contains('expulsions') ||
                    node.classList.contains('arrests') ||
                    node.classList.contains('referrals') ||
                    node.classList.contains('violence')
                )) {
                    // Found a chart indicator, apply patterns
                    setTimeout(function() {
                        applyPatternsFromStrings('student_discipline_bar_suspension');
                        applyPatternsFromStrings('student_discipline_bar_arrests');
                    }, 200);
                } else if (node.querySelector) {
                    // Check if any child elements are chart indicators
                    const indicators = node.querySelectorAll('.chart-color-indicator');
                    if (indicators.length > 0) {
                        setTimeout(function() {
                            applyPatternsFromStrings('student_discipline_bar_suspension');
                            applyPatternsFromStrings('student_discipline_bar_arrests');
                        }, 200);
                    }
                }
            }
        });
    });
});

// Start observing the document body for changes
if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
} else {
    document.addEventListener('DOMContentLoaded', function() {
        observer.observe(document.body, { childList: true, subtree: true });
    });
}

// === Teacher experience chart: orientation-aware (vertical desktop / horizontal mobile) ===

// Bootstrap's md breakpoint - matches the col-12 col-md-9 layout used by the chart's column.
function isTeacherExperienceMobile() {
    return window.innerWidth < 768;
}

function applyTeacherExperienceOrientation(options, mobile) {
    options.layout = options.layout || {};

    if (mobile) {
        // Horizontal bars: y = category axis, x = percentage (value) axis.
        options.indexAxis = 'y';
        options.scales = {
            x: {
                type: 'linear',
                display: false,
                beginAtZero: true,
                min: 0,
                max: 100,
                offset: false,
                grid: { display: false },
                ticks: { display: false },
                border: { display: false }
            },
            y: {
                type: 'category',
                display: true,
                offset: true,
                grid: { display: false },
                ticks: { display: true, font: { size: 13, weight: '500' } },
                border: { display: false }
            }
        };
        // Reserve room on the right for the inline "%  N" labels drawn by barLabels.
        options.layout.padding = { top: 10, bottom: 10, left: 0, right: 90 };
    } else {
        // Vertical bars: x = category, y = percentage. Matches the C# default config.
        options.indexAxis = 'x';
        options.scales = {
            x: {
                type: 'category',
                display: true,
                offset: true,
                grid: { display: false },
                ticks: { display: false },
                border: { display: false }
            },
            y: {
                type: 'linear',
                display: false,
                beginAtZero: true,
                min: 0,
                max: 100,
                grid: { display: false },
                ticks: { display: false },
                border: { display: false }
            }
        };
        options.layout.padding = { top: 25, bottom: 20, left: 0, right: 0 };
    }
}

// Track current orientation per chart instance so we only rebuild on breakpoint cross.
window._teacherExperienceMobileState = window._teacherExperienceMobileState || {};

function handleTeacherExperienceResize() {
    const chart = window.myCharts && window.myCharts.teacher_experience_bar;
    if (!chart) return;
    const mobile = isTeacherExperienceMobile();
    const prev = window._teacherExperienceMobileState.teacher_experience_bar;
    if (prev === mobile) return;
    window._teacherExperienceMobileState.teacher_experience_bar = mobile;
    applyTeacherExperienceOrientation(chart.options, mobile);
    chart.update();
}

let _teacherExperienceResizeTimer = null;
window.addEventListener('resize', function () {
    if (_teacherExperienceResizeTimer) clearTimeout(_teacherExperienceResizeTimer);
    _teacherExperienceResizeTimer = setTimeout(handleTeacherExperienceResize, 150);
});
